import { useTheme } from "@mui/material/styles";

const RefreshIcon = () => {
  const theme = useTheme();

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.0443 10.7442C16.8128 12.9191 15.5805 14.9572 13.5413 16.1345C10.1534 18.0905 5.82132 16.9298 3.86531 13.5419L3.65698 13.181M2.95527 9.25584C3.18677 7.08093 4.4191 5.04282 6.45825 3.86551C9.84616 1.90951 14.1783 3.07029 16.1343 6.45819L16.3426 6.81904M2.91113 15.055L3.52118 12.7783L5.79788 13.3884M14.2022 6.61167L16.4789 7.22172L17.0889 4.94501"
        stroke={theme.palette.primary.main}
        strokeWidth="1.65"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default RefreshIcon;
